(function () {
  'use strict';

  var configuratorRoot = document.querySelector('[data-custom-chopstick-configurator-root]');
  if (!configuratorRoot) return;

  var panel = configuratorRoot.querySelector('[data-custom-chopstick-configurator-app]');
  if (!panel || panel.getAttribute('data-configurator-app-initialized') === 'true') return;

  var STORAGE_KEY = 'ers:custom-chopstick-sleeve:configurator-draft';
  var SCHEMA_VERSION = 9;
  var ACTIVE_STAGE_LIMIT = 7;
  var DEBUG_MODE = /(?:\?|&)configurator_debug=1(?:&|$)/.test(window.location.search);
  var CREATE_STAGE_IDS = ['logo', 'content'];
  var CONTENT_MODULES = ['logo', 'restaurantName', 'restaurantInfo', 'message', 'additionalText'];
  var FIELD_CONTENT_MODULES = ['restaurantName', 'restaurantInfo', 'message', 'additionalText'];
  var CONTENT_LABELS = {
    logo: 'Logo',
    restaurantName: 'Restaurant name',
    restaurantInfo: 'Restaurant information',
    message: 'Message or instructions',
    additionalText: 'Additional text'
  };
  var SEMANTIC_LIMITS = {
    restaurantName: 120,
    'restaurantInfo.address': 240,
    'restaurantInfo.phone': 60,
    'restaurantInfo.contact': 160,
    message: 400,
    additionalText: 240
  };
  var WORKFLOW = [
    {
      id: 'logo',
      eyebrow: 'Create your sleeve',
      title: 'Start with your logo',
      description: 'Your logo is the starting point for a sleeve that feels distinctly yours.',
      support: 'Add one now, or continue without it and return later.',
      validate: validateLogoStage
    },
    {
      id: 'content',
      eyebrow: 'Choose your content',
      title: 'What should the sleeve include?',
      description: 'Select any combination that fits your restaurant and the guest experience.',
      support: 'These are independent content modules, not competing design styles.',
      validate: validateContentStage
    },
    {
      id: 'details',
      eyebrow: 'Add your details',
      title: 'Tell us what to include',
      description: 'Only the details needed for your selected content appear here.',
      support: 'You can go back and change the selection without losing what you entered.',
      validate: validateDetailsStage
    },
    {
      id: 'layouts',
      eyebrow: 'Optional inspiration',
      title: 'Need Inspiration?',
      description: 'Explore popular styles.',
      support: 'Your entered content remains available if you return to your own design.',
      validate: validateLayoutStage
    },
    {
      id: 'edit',
      eyebrow: 'Edit your design',
      title: 'Make the design yours',
      description: 'Work directly on the complete front and back print surfaces.',
      support: 'Select an object to reveal only the controls relevant to it.',
      validate: validateEditStage
    },
    {
      id: 'chopsticks',
      eyebrow: 'Choose your chopsticks',
      title: 'Choose your chopsticks',
      description: 'Select a style and quantity.',
      support: 'Your sleeve design stays saved while you configure the order.'
    },
    {
      id: 'review',
      eyebrow: 'Review',
      title: 'Review your order',
      description: 'Check your design and order information before sending it to ERS.',
      support: 'ERS will review the artwork and send a digital proof before production.'
    },
    {
      id: 'confirmation',
      eyebrow: 'Confirmation',
      title: 'All set.',
      description: 'Your design and order details have been received.',
      support: 'A digital proof comes next.'
    }
  ];

  var progressLabel = panel.querySelector('[data-configurator-progress-label]');
  var progress = panel.querySelector('[data-configurator-progress]');
  var progressValue = panel.querySelector('[data-configurator-progress-value]');
  var eyebrow = panel.querySelector('[data-configurator-stage-eyebrow]');
  var title = panel.querySelector('[data-configurator-stage-title]');
  var description = panel.querySelector('[data-configurator-stage-description]');
  var support = panel.querySelector('[data-configurator-stage-support]');
  var stageViews = panel.querySelectorAll('[data-configurator-stage-view]');
  var progressiveStage = panel.querySelector('[data-configurator-progressive-stage]');
  var subsectionElements = panel.querySelectorAll('[data-configurator-subsection]');
  var subsectionHeadings = panel.querySelectorAll('[data-configurator-subsection-heading]');
  var backButton = panel.querySelector('[data-configurator-back]');
  var nextButton = panel.querySelector('[data-configurator-next]');
  var readinessMessage = panel.querySelector('[data-configurator-readiness]');
  var logoInput = panel.querySelector('[data-configurator-logo-input]');
  var logoEmpty = panel.querySelector('[data-configurator-logo-empty]');
  var logoSummary = panel.querySelector('[data-configurator-logo-summary]');
  var logoThumbnail = panel.querySelector('[data-configurator-logo-thumbnail]');
  var logoName = panel.querySelector('[data-configurator-logo-name]');
  var logoMetadata = panel.querySelector('[data-configurator-logo-metadata]');
  var logoPlacementHelper = panel.querySelector('[data-configurator-logo-placement-helper]');
  var logoMessageElement = panel.querySelector('[data-configurator-logo-message]');
  var contentInputs = panel.querySelectorAll('[data-configurator-content-module]');
  var contentLogoStatus = panel.querySelector('[data-configurator-content-logo-status]');
  var contentLogoAction = panel.querySelector('[data-configurator-content-logo-action]');
  var contentEditors = panel.querySelectorAll('[data-configurator-content-edit]');
  var contentMessage = panel.querySelector('[data-configurator-content-message]');
  var detailModules = panel.querySelectorAll('[data-configurator-details-module]');
  var detailInputs = panel.querySelectorAll('[data-configurator-detail]');
  var detailErrors = panel.querySelectorAll('[data-configurator-details-error]');
  var layoutStatus = configuratorRoot.querySelector('[data-configurator-layout-status]');
  var layoutOptions = configuratorRoot.querySelector('[data-configurator-layout-options]');
  var layoutLogoRecovery = panel.querySelector('[data-configurator-layout-logo-recovery]');
  var logoAssetStore = configuratorRoot.logoAssets || null;
  var layoutEngine = configuratorRoot.configuratorLayouts || null;
  var designDocuments = configuratorRoot.configuratorDesignDocuments || null;
  var designRecipes = configuratorRoot.configuratorDesignRecipes || null;
  var sampleBrowser = configuratorRoot.configuratorSampleBrowser || null;
  var subscribers = [];
  var destroyed = false;
  var uploadBusy = false;
  var logoAssetStatus = 'none';
  var logoMessage = '';
  var logoMessageTone = '';
  var logoThumbnailAssetId = null;
  var logoThumbnailUrl = null;
  var layoutCandidates = [];
  var layoutCandidateFingerprint = null;
  var layoutPreparationStatus = 'idle';
  var layoutPreparationMessage = '';
  var layoutPreparationToken = 0;
  var restoration = restoreState();
  var state = restoration.state;
  var expandedContentModule = preferredExpandedModule(state);

  if (normalizeDesignForConfiguration(state.configuration)) restoration.normalized = true;

  if (state.workflow.currentStage === 'details') {
    state.workflow.currentStage = 'content';
    state.workflow.visitedStages = addUnique(state.workflow.visitedStages, 'content');
    restoration.normalized = true;
  }

  if (!DEBUG_MODE && stageIndex(state.workflow.currentStage) > ACTIVE_STAGE_LIMIT) {
    state.workflow.currentStage = WORKFLOW[ACTIVE_STAGE_LIMIT].id;
    restoration.normalized = true;
  }
  if (state.configuration.logo) logoAssetStatus = 'loading';

  panel.setAttribute('data-configurator-app-initialized', 'true');
  configuratorRoot.classList.toggle('is-configurator-debug', DEBUG_MODE);
  configuratorRoot.setAttribute('data-configurator-schema-version', String(SCHEMA_VERSION));
  if (designDocuments) configuratorRoot.setAttribute('data-configurator-design-document-version', String(designDocuments.version));
  configuratorRoot.setAttribute('data-configurator-draft-restored', restoration.restored ? 'true' : 'false');
  if (restoration.invalidated) configuratorRoot.setAttribute('data-configurator-draft-invalidated', 'true');
  if (restoration.migrated) configuratorRoot.setAttribute('data-configurator-draft-migrated', 'true');

  function createEmptyDesign() {
    return { document: null };
  }

  function normalizeDesignForConfiguration(configuration) {
    var document = configuration.design && configuration.design.document;
    var normalized = false;
    if (document && designRecipes && typeof designRecipes.upgradeDocument === 'function') {
      var upgraded = designRecipes.upgradeDocument(document, configuration);
      if (upgraded && JSON.stringify(upgraded) !== JSON.stringify(document)) {
        configuration.design.document = upgraded;
        document = upgraded;
        normalized = true;
      }
    }
    if (document && designDocuments && designDocuments.validateDocument(document, configuration)) return normalized;
    if (!configuration.design || document !== null) {
      configuration.design = createEmptyDesign();
      return true;
    }
    return false;
  }

  function createInitialState() {
    return {
      workflow: {
        currentStage: WORKFLOW[0].id,
        visitedStages: [WORKFLOW[0].id],
        completedStages: []
      },
      configuration: {
        logo: null,
        content: {
          enabledTypes: [],
          values: {
            restaurantName: '',
            restaurantInfo: {
              address: '',
              phone: '',
              contact: ''
            },
            message: '',
            additionalText: ''
          }
        },
        design: createEmptyDesign(),
        order: {
          chopstickId: null,
          quantity: null,
          printColors: null,
          contactEmail: ''
        }
      }
    };
  }

  function isPlainObject(value) {
    return Object.prototype.toString.call(value) === '[object Object]';
  }

  function isStringArray(value) {
    return Array.isArray(value) && value.every(function (item) { return typeof item === 'string'; });
  }

  function isKnownStage(stageId) {
    return WORKFLOW.some(function (stage) { return stage.id === stageId; });
  }

  function isKnownContentModule(moduleId) {
    return CONTENT_MODULES.indexOf(moduleId) !== -1;
  }

  function migrateWorkflowStage(stageId) {
    if (stageId === 'arrangement' || stageId === 'refinement') return 'edit';
    if (stageId === 'order') return 'chopsticks';
    if (stageId === 'submission') return 'review';
    return stageId;
  }

  function normalizeOrderState(candidate) {
    if (!candidate || !candidate.configuration) return candidate;
    if (!isPlainObject(candidate.configuration.order)) {
      candidate.configuration.order = { chopstickId: null, quantity: null, printColors: null, contactEmail: '' };
      return candidate;
    }
    if (candidate.configuration.order.printColors !== 1 && candidate.configuration.order.printColors !== 2) {
      candidate.configuration.order.printColors = null;
    }
    if (typeof candidate.configuration.order.contactEmail !== 'string') {
      candidate.configuration.order.contactEmail = '';
    }
    return candidate;
  }

  function migrateWorkflow(workflow) {
    if (!isPlainObject(workflow)) return workflow;
    workflow.currentStage = migrateWorkflowStage(workflow.currentStage);
    workflow.visitedStages = Array.isArray(workflow.visitedStages)
      ? workflow.visitedStages.map(migrateWorkflowStage).filter(function (stageId, index, stages) {
        return isKnownStage(stageId) && stages.indexOf(stageId) === index;
      })
      : [];
    workflow.completedStages = Array.isArray(workflow.completedStages)
      ? workflow.completedStages.map(migrateWorkflowStage).filter(function (stageId, index, stages) {
        return isKnownStage(stageId) && stages.indexOf(stageId) === index;
      })
      : [];
    if (workflow.visitedStages.indexOf(workflow.currentStage) === -1) {
      workflow.visitedStages.push(workflow.currentStage);
    }
    return workflow;
  }

  function isValidLogoMetadata(logo) {
    if (logo === null) return true;
    return Boolean(
      isPlainObject(logo) &&
      typeof logo.assetId === 'string' && logo.assetId.length > 0 &&
      typeof logo.name === 'string' &&
      typeof logo.type === 'string' &&
      typeof logo.size === 'number' && logo.size > 0 &&
      typeof logo.width === 'number' && logo.width > 0 &&
      typeof logo.height === 'number' && logo.height > 0 &&
      typeof logo.updatedAt === 'number'
    );
  }

  function isValidState(candidate) {
    if (!isPlainObject(candidate) || !isPlainObject(candidate.workflow) || !isPlainObject(candidate.configuration)) return false;
    if (!isKnownStage(candidate.workflow.currentStage)) return false;
    if (!isStringArray(candidate.workflow.visitedStages) || !candidate.workflow.visitedStages.every(isKnownStage)) return false;
    if (!isStringArray(candidate.workflow.completedStages) || !candidate.workflow.completedStages.every(isKnownStage)) return false;

    var configuration = candidate.configuration;
    if (!isValidLogoMetadata(configuration.logo)) return false;
    if (!isPlainObject(configuration.content) || !isStringArray(configuration.content.enabledTypes)) return false;
    if (!configuration.content.enabledTypes.every(isKnownContentModule) || !isPlainObject(configuration.content.values)) return false;

    var values = configuration.content.values;
    if (typeof values.restaurantName !== 'string' || !isPlainObject(values.restaurantInfo)) return false;
    if (typeof values.restaurantInfo.address !== 'string' || typeof values.restaurantInfo.phone !== 'string') return false;
    if (typeof values.restaurantInfo.contact !== 'string' || typeof values.message !== 'string' || typeof values.additionalText !== 'string') return false;
    if (values.restaurantName.length > SEMANTIC_LIMITS.restaurantName) return false;
    if (values.restaurantInfo.address.length > SEMANTIC_LIMITS['restaurantInfo.address']) return false;
    if (values.restaurantInfo.phone.length > SEMANTIC_LIMITS['restaurantInfo.phone']) return false;
    if (values.restaurantInfo.contact.length > SEMANTIC_LIMITS['restaurantInfo.contact']) return false;
    if (values.message.length > SEMANTIC_LIMITS.message || values.additionalText.length > SEMANTIC_LIMITS.additionalText) return false;

    if (!isPlainObject(configuration.design)) return false;
    if (
      configuration.design.document !== null &&
      (!designDocuments || !designDocuments.validateDocument(configuration.design.document, configuration))
    ) return false;
    if (!isPlainObject(configuration.order)) return false;
    if (configuration.order.chopstickId !== null && typeof configuration.order.chopstickId !== 'string') return false;
    if (configuration.order.quantity !== null && typeof configuration.order.quantity !== 'number') return false;
    if (configuration.order.printColors !== null && configuration.order.printColors !== 1 && configuration.order.printColors !== 2) return false;
    if (typeof configuration.order.contactEmail !== 'string' || configuration.order.contactEmail.length > 254) return false;
    return true;
  }

  function clone(value) {
    return JSON.parse(JSON.stringify(value));
  }

  function migrateStateDocument(candidate) {
    if (
      !candidate ||
      !candidate.configuration ||
      !candidate.configuration.design ||
      !candidate.configuration.design.document ||
      !designDocuments ||
      typeof designDocuments.migrateDocument !== 'function'
    ) return candidate;
    var migrated = designDocuments.migrateDocument(candidate.configuration.design.document);
    if (!migrated) return null;
    if (designRecipes && typeof designRecipes.upgradeDocument === 'function') {
      migrated = designRecipes.upgradeDocument(migrated, candidate.configuration);
    }
    candidate.configuration.design.document = migrated;
    return candidate;
  }

  function readStorage() {
    try {
      var storage = window.sessionStorage;
      storage.getItem(STORAGE_KEY);
      configuratorRoot.setAttribute('data-configurator-storage', 'available');
      return storage;
    } catch (error) {
      configuratorRoot.setAttribute('data-configurator-storage', 'unavailable');
      return null;
    }
  }

  function discardPersistedState(storage) {
    if (!storage) return;
    try {
      storage.removeItem(STORAGE_KEY);
    } catch (error) {
      configuratorRoot.setAttribute('data-configurator-storage', 'unavailable');
    }
  }

  function restoreState() {
    var storage = readStorage();
    var initialState = createInitialState();
    if (!storage) return { state: initialState, restored: false, invalidated: false, migrated: false, discardedLogoAssetId: null };

    var rawDraft;
    var discardedLogoAssetId = null;
    try {
      rawDraft = storage.getItem(STORAGE_KEY);
      if (!rawDraft) return { state: initialState, restored: false, invalidated: false, migrated: false, discardedLogoAssetId: null };
      var envelope = JSON.parse(rawDraft);

      if (
        isPlainObject(envelope) &&
        (envelope.schemaVersion === 2 || envelope.schemaVersion === 3) &&
        isPlainObject(envelope.state) &&
        isPlainObject(envelope.state.configuration)
      ) {
        var migratedState = normalizeOrderState(clone(envelope.state));
        migrateWorkflow(migratedState.workflow);
        var migratedDocument = null;
        var legacyDesign = migratedState.configuration.design;
        if (
          envelope.schemaVersion === 3 &&
          legacyDesign &&
          legacyDesign.composition &&
          layoutEngine &&
          designDocuments &&
          layoutEngine.validateComposition(legacyDesign.composition, migratedState.configuration)
        ) {
          migratedDocument = designDocuments.migrateComposition(legacyDesign.composition, migratedState.configuration);
        }
        migratedState.configuration.design = { document: migratedDocument };
        if (isValidState(migratedState)) {
          return { state: migratedState, restored: true, invalidated: false, migrated: true, discardedLogoAssetId: null };
        }
      }

      if (isPlainObject(envelope) && envelope.schemaVersion === 4 && isPlainObject(envelope.state)) {
        var versionFourState = normalizeOrderState(clone(envelope.state));
        migrateWorkflow(versionFourState.workflow);
        versionFourState = migrateStateDocument(versionFourState);
        if (isValidState(versionFourState)) {
          return { state: versionFourState, restored: true, invalidated: false, migrated: true, discardedLogoAssetId: null };
        }
      }

      if (isPlainObject(envelope) && envelope.schemaVersion === 5 && isPlainObject(envelope.state)) {
        var versionFiveState = normalizeOrderState(clone(envelope.state));
        migrateWorkflow(versionFiveState.workflow);
        versionFiveState = migrateStateDocument(versionFiveState);
        if (isValidState(versionFiveState)) {
          return { state: versionFiveState, restored: true, invalidated: false, migrated: true, discardedLogoAssetId: null };
        }
      }

      if (isPlainObject(envelope) && envelope.schemaVersion === 6 && isPlainObject(envelope.state)) {
        var versionSixState = normalizeOrderState(clone(envelope.state));
        migrateWorkflow(versionSixState.workflow);
        versionSixState = migrateStateDocument(versionSixState);
        if (isValidState(versionSixState)) {
          return { state: versionSixState, restored: true, invalidated: false, migrated: true, discardedLogoAssetId: null };
        }
      }

      if (isPlainObject(envelope) && envelope.schemaVersion === 7 && isPlainObject(envelope.state)) {
        var versionSevenState = normalizeOrderState(clone(envelope.state));
        migrateWorkflow(versionSevenState.workflow);
        versionSevenState = migrateStateDocument(versionSevenState);
        if (isValidState(versionSevenState)) {
          return { state: versionSevenState, restored: true, invalidated: false, migrated: true, discardedLogoAssetId: null };
        }
      }

      if (isPlainObject(envelope) && envelope.schemaVersion === 8 && isPlainObject(envelope.state)) {
        var versionEightState = normalizeOrderState(clone(envelope.state));
        migrateWorkflow(versionEightState.workflow);
        versionEightState = migrateStateDocument(versionEightState);
        if (isValidState(versionEightState)) {
          return { state: versionEightState, restored: true, invalidated: false, migrated: true, discardedLogoAssetId: null };
        }
      }

      if (isPlainObject(envelope) && envelope.schemaVersion === SCHEMA_VERSION && isPlainObject(envelope.state)) {
        var currentState = normalizeOrderState(clone(envelope.state));
        if (isValidState(currentState)) {
          return { state: currentState, restored: true, invalidated: false, migrated: false, discardedLogoAssetId: null };
        }
        if (isPlainObject(envelope.state.configuration)) {
          var recoveredState = clone(envelope.state);
          recoveredState.configuration.design = createEmptyDesign();
          if (isValidState(recoveredState)) {
            return {
              state: recoveredState,
              restored: true,
              invalidated: false,
              migrated: false,
              normalized: true,
              discardedLogoAssetId: null
            };
          }
        }
      }

      if (!isPlainObject(envelope) || envelope.schemaVersion !== SCHEMA_VERSION || !isValidState(envelope.state)) {
        if (
          isPlainObject(envelope) &&
          isPlainObject(envelope.state) &&
          isPlainObject(envelope.state.configuration) &&
          isPlainObject(envelope.state.configuration.logo) &&
          typeof envelope.state.configuration.logo.assetId === 'string'
        ) {
          discardedLogoAssetId = envelope.state.configuration.logo.assetId;
        }
        discardPersistedState(storage);
        return { state: initialState, restored: false, invalidated: true, migrated: false, discardedLogoAssetId: discardedLogoAssetId };
      }
    } catch (error) {
      discardPersistedState(storage);
      return { state: initialState, restored: false, invalidated: Boolean(rawDraft), migrated: false, discardedLogoAssetId: null };
    }
  }

  function persistState() {
    var storage = readStorage();
    if (!storage) return false;
    try {
      storage.setItem(STORAGE_KEY, JSON.stringify({
        schemaVersion: SCHEMA_VERSION,
        savedAt: new Date().toISOString(),
        state: state
      }));
      return true;
    } catch (error) {
      configuratorRoot.setAttribute('data-configurator-storage', 'unavailable');
      return false;
    }
  }

  function mergeConfiguration(base, patch) {
    var merged = clone(base);
    Object.keys(patch).forEach(function (key) {
      if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
      if (isPlainObject(patch[key]) && isPlainObject(merged[key])) {
        merged[key] = mergeConfiguration(merged[key], patch[key]);
      } else {
        merged[key] = clone(patch[key]);
      }
    });
    return merged;
  }

  function stageIndex(stageId) {
    return WORKFLOW.findIndex(function (stage) { return stage.id === stageId; });
  }

  function currentStage() {
    return WORKFLOW[stageIndex(state.workflow.currentStage)];
  }

  function isCreateStage(stageId) {
    return CREATE_STAGE_IDS.indexOf(stageId) !== -1;
  }

  function activeModules(snapshot) {
    return snapshot.configuration.content.enabledTypes;
  }

  function hasMeaningfulText(value) {
    return typeof value === 'string' && value.trim().length >= 2;
  }

  function logoReadiness(snapshot) {
    if (!snapshot.configuration.logo) return { ready: false, reason: 'Add a logo before including it.' };
    if (logoAssetStatus === 'loading') return { ready: false, reason: 'Restoring your logo…' };
    if (logoAssetStatus !== 'ready') return { ready: false, reason: 'That logo is no longer available. Add it again.' };
    return { ready: true, reason: '' };
  }

  function validateLogoStage(snapshot) {
    if (!snapshot.configuration.logo) return { ready: true, reason: '', errors: {} };
    var readiness = logoReadiness(snapshot);
    return { ready: readiness.ready, reason: readiness.reason, errors: readiness.ready ? {} : { logo: readiness.reason } };
  }

  function validateContentStage(snapshot) {
    var enabled = activeModules(snapshot);
    if (!enabled.length) {
      return { ready: false, reason: 'Choose at least one type of content to continue.', errors: { content: 'Choose one or more items.' } };
    }
    if (enabled.indexOf('logo') !== -1) {
      var logo = logoReadiness(snapshot);
      if (!logo.ready) return { ready: false, reason: logo.reason, errors: { logo: logo.reason } };
    }
    return { ready: true, reason: '', errors: {} };
  }

  function validateDetailsStage(snapshot) {
    var enabled = activeModules(snapshot);
    var values = snapshot.configuration.content.values;
    var errors = {};

    if (enabled.indexOf('logo') !== -1) {
      var logo = logoReadiness(snapshot);
      if (!logo.ready) errors.logo = logo.reason;
    }
    if (enabled.indexOf('restaurantName') !== -1 && !hasMeaningfulText(values.restaurantName)) {
      errors.restaurantName = 'Enter the restaurant name.';
    }
    if (enabled.indexOf('restaurantInfo') !== -1) {
      var restaurantInfo = values.restaurantInfo;
      if (!hasMeaningfulText(restaurantInfo.address) && !hasMeaningfulText(restaurantInfo.phone) && !hasMeaningfulText(restaurantInfo.contact)) {
        errors.restaurantInfo = 'Add at least one useful restaurant detail.';
      }
    }
    if (enabled.indexOf('message') !== -1 && !hasMeaningfulText(values.message)) {
      errors.message = 'Enter the message or instructions.';
    }
    if (enabled.indexOf('additionalText') !== -1 && !hasMeaningfulText(values.additionalText)) {
      errors.additionalText = 'Enter the additional text.';
    }

    var ready = Object.keys(errors).length === 0 && enabled.length > 0;
    return {
      ready: ready,
      reason: ready ? '' : enabled.length ? 'Complete the highlighted details to continue.' : 'Choose content before adding details.',
      errors: errors
    };
  }

  function preferredExpandedModule(snapshot) {
    var enabled = activeModules(snapshot);
    var errors = validateDetailsStage(snapshot).errors;
    return FIELD_CONTENT_MODULES.find(function (moduleId) {
      return enabled.indexOf(moduleId) !== -1 && Boolean(errors[moduleId]);
    }) || FIELD_CONTENT_MODULES.find(function (moduleId) {
      return enabled.indexOf(moduleId) !== -1;
    }) || null;
  }

  function validateLayoutStage(snapshot) {
    var detailsReadiness = validateDetailsStage(snapshot);
    if (!detailsReadiness.ready) return detailsReadiness;
    if (!layoutEngine || !designDocuments || !designRecipes || !sampleBrowser) {
      return { ready: false, reason: 'Design choices could not be prepared. Refresh and try again.', errors: { layout: 'Design preparation is unavailable.' } };
    }
    if (layoutPreparationStatus === 'loading' || layoutPreparationStatus === 'idle') {
      return { ready: false, reason: 'Preparing your designs…', errors: {} };
    }
    if (layoutPreparationStatus === 'missing-logo') {
      return { ready: false, reason: 'Re-upload the logo to prepare your designs.', errors: { logo: layoutPreparationMessage } };
    }
    if (layoutPreparationStatus === 'error') {
      return { ready: false, reason: layoutPreparationMessage || 'Design choices could not be prepared.', errors: { layout: layoutPreparationMessage } };
    }

    var design = snapshot.configuration.design;
    if (!design.document || !designDocuments.validateDocument(design.document, snapshot.configuration)) {
      return { ready: false, reason: 'Choose a design to continue.', errors: { layout: 'Choose a design.' } };
    }
    return { ready: true, reason: '', errors: {} };
  }

  function validateEditStage(snapshot) {
    var design = snapshot.configuration.design;
    if (!design.document || !designDocuments || !designDocuments.validateDocument(design.document, snapshot.configuration)) {
      return { ready: false, reason: 'Choose a design before editing it.', errors: { design: 'Choose a design.' } };
    }
    return { ready: true, reason: '', errors: {} };
  }

  function currentReadiness() {
    var stage = currentStage();
    if (!stage) return { ready: false, reason: 'This workflow stage is unavailable.', errors: {} };
    if (stage.id === 'content') return validateDetailsStage(state);
    if (typeof stage.validate === 'function') return stage.validate(state);
    return { ready: true, reason: '', errors: {} };
  }

  function notify(action) {
    var snapshot = clone(state);
    subscribers.slice().forEach(function (subscriber) {
      subscriber(snapshot, action);
    });
  }

  function commit(nextState, action) {
    if (destroyed || !isValidState(nextState)) return false;
    state = nextState;
    persistState();
    notify(action);
    return true;
  }

  function addUnique(items, value) {
    var next = items.slice();
    if (next.indexOf(value) === -1) next.push(value);
    return next;
  }

  function withoutValue(items, value) {
    return items.filter(function (item) { return item !== value; });
  }

  function enterEditor(nextState, actionType) {
    var document = nextState.configuration.design.document;
    if (!document || !designDocuments || !designDocuments.validateDocument(document, nextState.configuration)) {
      document = designRecipes && designRecipes.instantiate('create-my-own', nextState.configuration);
    }
    if (!document) return false;
    nextState.configuration.design = { document: document };
    nextState.workflow.currentStage = 'edit';
    nextState.workflow.visitedStages = addUnique(nextState.workflow.visitedStages, 'edit');
    return commit(nextState, { type: actionType, stage: 'edit', focus: true });
  }

  function goToStage(stageId, options) {
    if (stageId === 'details') stageId = 'content';
    var targetIndex = stageIndex(stageId);
    if (targetIndex < 0 || destroyed || (!DEBUG_MODE && targetIndex > ACTIVE_STAGE_LIMIT)) return false;
    var nextState = clone(state);
    nextState.workflow.currentStage = stageId;
    nextState.workflow.visitedStages = addUnique(nextState.workflow.visitedStages, stageId);
    return commit(nextState, {
      type: 'workflow:go-to',
      stage: stageId,
      focus: !options || options.focus !== false
    });
  }

  function goNext() {
    var readiness = currentReadiness();
    var index = stageIndex(state.workflow.currentStage);
    var lastAvailableStage = DEBUG_MODE ? WORKFLOW.length - 1 : ACTIVE_STAGE_LIMIT;
    if (!readiness.ready || index < 0 || index >= lastAvailableStage) return false;
    var nextState = clone(state);
    nextState.workflow.completedStages = addUnique(nextState.workflow.completedStages, state.workflow.currentStage);
    if (state.workflow.currentStage === 'content') {
      nextState.workflow.completedStages = addUnique(nextState.workflow.completedStages, 'details');
      return enterEditor(nextState, 'workflow:content-to-editor');
    }
    nextState.workflow.currentStage = WORKFLOW[index + 1].id;
    nextState.workflow.visitedStages = addUnique(nextState.workflow.visitedStages, nextState.workflow.currentStage);
    return commit(nextState, { type: 'workflow:next', stage: nextState.workflow.currentStage, focus: true });
  }

  function goBack() {
    if (state.workflow.currentStage === 'layouts') return enterEditor(clone(state), 'workflow:inspiration-to-editor');
    if (state.workflow.currentStage === 'edit') return goToStage('content');
    var index = stageIndex(state.workflow.currentStage);
    if (index <= 0) return false;
    return goToStage(WORKFLOW[index - 1].id);
  }

  function updateConfiguration(patch) {
    if (!isPlainObject(patch) || destroyed || Object.prototype.hasOwnProperty.call(patch, 'design')) return false;
    var nextState = clone(state);
    var previousConfiguration = clone(nextState.configuration);
    try {
      nextState.configuration = mergeConfiguration(nextState.configuration, patch);
    } catch (error) {
      return false;
    }
    if (!isValidSemanticValues(nextState.configuration.content && nextState.configuration.content.values)) return false;

    var reconciliation = { status: 'empty' };
    if (designDocuments) {
      reconciliation = designDocuments.reconcileDocument(
        previousConfiguration.design.document,
        previousConfiguration,
        nextState.configuration
      );
      if (
        reconciliation.status === 'invalidated-structure' &&
        previousConfiguration.design.document &&
        designRecipes
      ) {
        var reinstantiated = designRecipes.instantiate(
          previousConfiguration.design.document.provenance.sourceId,
          nextState.configuration
        );
        if (reinstantiated && designDocuments.carryDeletedObjects) {
          reinstantiated = designDocuments.carryDeletedObjects(
            previousConfiguration.design.document,
            reinstantiated
          );
        }
        if (reinstantiated) reconciliation = { document: reinstantiated, status: 'reinstantiated-structure' };
      }
      nextState.configuration.design = { document: reconciliation.document };
    }
    var actionType = 'configuration:update';
    if (reconciliation.status === 'preserved-value' || reconciliation.status === 'preserved-dormancy') {
      actionType = 'configuration:update-design-preserved';
    }
    if (reconciliation.status === 'reinstantiated-structure') actionType = 'configuration:update-design-reinstantiated';
    if (reconciliation.status === 'invalidated' || reconciliation.status === 'invalidated-structure') {
      actionType = 'configuration:update-design-invalidated';
    }
    return commit(nextState, {
      type: actionType,
      designReconciliation: reconciliation.status,
      focus: false
    });
  }

  function isValidSemanticValues(values) {
    if (!isPlainObject(values) || !isPlainObject(values.restaurantInfo)) return false;
    return typeof values.restaurantName === 'string' && values.restaurantName.length <= SEMANTIC_LIMITS.restaurantName &&
      typeof values.restaurantInfo.address === 'string' && values.restaurantInfo.address.length <= SEMANTIC_LIMITS['restaurantInfo.address'] &&
      typeof values.restaurantInfo.phone === 'string' && values.restaurantInfo.phone.length <= SEMANTIC_LIMITS['restaurantInfo.phone'] &&
      typeof values.restaurantInfo.contact === 'string' && values.restaurantInfo.contact.length <= SEMANTIC_LIMITS['restaurantInfo.contact'] &&
      typeof values.message === 'string' && values.message.length <= SEMANTIC_LIMITS.message &&
      typeof values.additionalText === 'string' && values.additionalText.length <= SEMANTIC_LIMITS.additionalText;
  }

  function designAssetIds(configuration) {
    var keep = [];
    if (configuration.logo && configuration.logo.assetId) keep.push(configuration.logo.assetId);
    var design = configuration.design && configuration.design.document;
    if (!design || !design.sides) return keep;
    design.sides.front.objects.concat(design.sides.back.objects).forEach(function (object) {
      if (
        object.type === 'image' && object.assetRef && object.assetRef.kind === 'design' &&
        keep.indexOf(object.assetRef.assetId) === -1
      ) keep.push(object.assetRef.assetId);
    });
    return keep;
  }

  function updateDesignDocument(document, options) {
    if (destroyed || !designDocuments) return false;
    if (document !== null && !designDocuments.validateDocument(document, state.configuration)) return false;
    var nextState = clone(state);
    nextState.configuration.design = { document: document === null ? null : clone(document) };
    return commit(nextState, {
      type: options && options.type ? options.type : 'design-document:update',
      focus: false
    });
  }

  function resetDesignDocument() {
    var currentDocument = state.configuration.design.document;
    if (!currentDocument || !designRecipes) return false;
    var pristine = designRecipes.instantiate(currentDocument.provenance.sourceId, state.configuration);
    if (!pristine) return false;
    return updateDesignDocument(pristine, { type: 'design-document:reset-to-origin' });
  }

  function subscribe(subscriber) {
    if (typeof subscriber !== 'function' || destroyed) return function () {};
    subscribers.push(subscriber);
    return function () {
      var index = subscribers.indexOf(subscriber);
      if (index !== -1) subscribers.splice(index, 1);
    };
  }

  function formatFileSize(bytes) {
    if (bytes < 1024 * 1024) return Math.max(1, Math.round(bytes / 1024)) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1).replace(/\.0$/, '') + ' MB';
  }

  function revokeLogoThumbnail() {
    if (logoThumbnailUrl) URL.revokeObjectURL(logoThumbnailUrl);
    logoThumbnailUrl = null;
    logoThumbnailAssetId = null;
    logoThumbnail.removeAttribute('src');
  }

  function syncLogoThumbnail(logo) {
    if (!logo || logoAssetStatus !== 'ready' || !logoAssetStore) {
      if (!logo) revokeLogoThumbnail();
      return;
    }
    if (logoThumbnailAssetId === logo.assetId) return;

    revokeLogoThumbnail();
    logoThumbnailAssetId = logo.assetId;
    logoAssetStore.get(logo.assetId).then(function (record) {
      if (destroyed || !record || !state.configuration.logo || state.configuration.logo.assetId !== logo.assetId) return;
      logoThumbnailUrl = URL.createObjectURL(record.blob);
      logoThumbnail.src = logoThumbnailUrl;
      logoThumbnail.alt = 'Preview of ' + logo.name;
    });
  }

  function renderLogo(snapshot) {
    var logo = snapshot.configuration.logo;
    var hasLogo = Boolean(logo);
    logoEmpty.hidden = hasLogo;
    logoSummary.hidden = !hasLogo;
    logoPlacementHelper.hidden = !hasLogo || logoAssetStatus !== 'ready';
    logoInput.disabled = uploadBusy;
    logoMessageElement.textContent = logoMessage;
    logoMessageElement.setAttribute('data-message-tone', logoMessageTone);

    if (!logo) {
      revokeLogoThumbnail();
      return;
    }

    logoName.textContent = logo.name;
    logoMetadata.textContent = logo.width + ' × ' + logo.height + ' px · ' + formatFileSize(logo.size);
    syncLogoThumbnail(logo);
  }

  function renderContent(snapshot, readiness) {
    var enabled = activeModules(snapshot);
    Array.prototype.forEach.call(contentInputs, function (input) {
      var active = enabled.indexOf(input.value) !== -1;
      input.checked = active;
      if (input.hasAttribute('aria-controls')) {
        input.setAttribute('aria-expanded', active && expandedContentModule === input.value ? 'true' : 'false');
      }
    });
    Array.prototype.forEach.call(contentEditors, function (editor) {
      var moduleId = editor.getAttribute('data-configurator-content-edit');
      var enabledModule = enabled.indexOf(moduleId) !== -1;
      var expanded = enabledModule && expandedContentModule === moduleId;
      var invalid = enabledModule && Boolean(readiness.errors[moduleId]);
      editor.hidden = !enabledModule;
      editor.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      editor.textContent = invalid && !expanded ? 'Complete' : expanded ? 'Done' : 'Edit';
    });

    if (snapshot.configuration.logo && logoAssetStatus === 'ready') {
      contentLogoStatus.textContent = snapshot.configuration.logo.name + ' is ready to use.';
    } else {
      contentLogoStatus.textContent = 'No logo is currently available.';
    }
    contentLogoAction.hidden = !(enabled.indexOf('logo') !== -1 && (!snapshot.configuration.logo || logoAssetStatus !== 'ready'));
    contentMessage.textContent = readiness.ready ? '' : readiness.errors.content || readiness.errors.logo || '';
  }

  function setInputValue(input, value) {
    if (document.activeElement !== input && input.value !== value) input.value = value;
  }

  function renderDetails(snapshot, readiness) {
    var enabled = activeModules(snapshot);
    var values = snapshot.configuration.content.values;

    Array.prototype.forEach.call(detailModules, function (module) {
      var moduleId = module.getAttribute('data-configurator-details-module');
      var enabledModule = enabled.indexOf(moduleId) !== -1;
      var active = enabledModule && expandedContentModule === moduleId;
      module.hidden = false;
      module.setAttribute('data-active', active ? 'true' : 'false');
      module.setAttribute('aria-hidden', active ? 'false' : 'true');
      module.parentElement.setAttribute('data-enabled', enabledModule ? 'true' : 'false');
      module.parentElement.setAttribute('data-expanded', active ? 'true' : 'false');
      module.parentElement.setAttribute('data-invalid', enabledModule && readiness.errors[moduleId] ? 'true' : 'false');
      if (active) module.removeAttribute('inert');
      else module.setAttribute('inert', '');
    });

    Array.prototype.forEach.call(detailInputs, function (input) {
      var key = input.getAttribute('data-configurator-detail');
      if (key.indexOf('restaurantInfo.') === 0) {
        setInputValue(input, values.restaurantInfo[key.split('.')[1]] || '');
      } else {
        setInputValue(input, values[key] || '');
      }
    });

    Array.prototype.forEach.call(detailErrors, function (error) {
      var key = error.getAttribute('data-configurator-details-error');
      error.textContent = readiness.errors[key] || '';
    });
  }

  function renderLayoutArrival(snapshot) {
    layoutLogoRecovery.hidden = logoAssetStatus !== 'missing';
    layoutStatus.textContent = layoutPreparationMessage;
    layoutStatus.setAttribute('data-message-tone', layoutPreparationStatus === 'error' ? 'error' : '');

    var selectedDocument = snapshot.configuration.design.document;
    var selectedLayoutId = selectedDocument ? selectedDocument.provenance.sourceId : null;
    Array.prototype.forEach.call(layoutOptions.querySelectorAll('[data-configurator-layout-option]'), function (option) {
      var selected = option.getAttribute('data-configurator-layout-option') === selectedLayoutId;
      option.classList.toggle('is-selected', selected);
      option.setAttribute('aria-checked', selected ? 'true' : 'false');
      var marker = option.querySelector('[data-configurator-layout-selected]');
      if (marker) marker.hidden = !selected;
    });
  }

  function renderProgressiveStage(snapshot, activeStageId) {
    var createStageActive = isCreateStage(activeStageId);
    progressiveStage.hidden = !createStageActive;
    Array.prototype.forEach.call(subsectionElements, function (section) {
      var subsectionId = section.getAttribute('data-configurator-subsection');
      var revealed = createStageActive && (
        subsectionId === activeStageId ||
        snapshot.workflow.visitedStages.indexOf(subsectionId) !== -1
      );
      var active = revealed && subsectionId === activeStageId;
      var subsectionStage = WORKFLOW[stageIndex(subsectionId)];
      var subsectionReadiness = subsectionId === 'content'
        ? validateDetailsStage(snapshot)
        : subsectionStage && typeof subsectionStage.validate === 'function'
          ? subsectionStage.validate(snapshot)
          : { ready: true };
      var completed = revealed && !active && subsectionReadiness.ready &&
        snapshot.workflow.completedStages.indexOf(subsectionId) !== -1;
      var trigger = section.querySelector('[data-configurator-subsection-trigger]');
      var check = section.querySelector('[data-configurator-subsection-check]');

      section.hidden = !revealed;
      section.setAttribute('data-active', active ? 'true' : 'false');
      section.setAttribute('data-completed', completed ? 'true' : 'false');
      trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
      if (active) trigger.setAttribute('aria-current', 'step');
      else trigger.removeAttribute('aria-current');
      check.hidden = !completed;
    });
  }

  function createCandidateOption(candidate) {
    var option = document.createElement('button');
    option.type = 'button';
    option.className = 'custom-chopstick-configurator-layout-option';
    option.setAttribute('role', 'radio');
    option.setAttribute('aria-checked', 'false');
    option.setAttribute('data-configurator-layout-option', candidate.id);
    option.setAttribute('data-configurator-layout-kind', candidate.kind || 'design');

    var heading = document.createElement('span');
    heading.className = 'custom-chopstick-configurator-layout-option__heading';
    var label = document.createElement('strong');
    label.textContent = candidate.label;
    var selected = document.createElement('span');
    selected.textContent = 'Selected';
    selected.hidden = true;
    selected.setAttribute('data-configurator-layout-selected', '');
    heading.appendChild(label);
    heading.appendChild(selected);

    var descriptionElement = document.createElement('small');
    descriptionElement.textContent = candidate.description;
    var preview = document.createElement('span');
    preview.className = 'custom-chopstick-configurator-layout-option__preview';
    if (candidate.kind === 'create-my-own') {
      preview.classList.add('custom-chopstick-configurator-layout-option__preview--create-own');
      preview.setAttribute('data-sample-preview-status', 'ready');
      var blankSleeve = document.createElement('span');
      blankSleeve.className = 'custom-chopstick-configurator-layout-option__blank-sleeve';
      blankSleeve.textContent = 'Your design';
      preview.appendChild(blankSleeve);
    } else {
      preview.setAttribute('data-configurator-sample-preview', '');
    }

    option.appendChild(preview);
    option.appendChild(heading);
    option.appendChild(descriptionElement);
    return option;
  }

  function buildCandidateOptions(candidates, token) {
    if (sampleBrowser) sampleBrowser.clear();
    layoutOptions.textContent = '';
    var fragment = document.createDocumentFragment();
    var candidateOptions = candidates.filter(function (candidate) {
      return candidate.kind !== 'create-my-own';
    }).map(function (candidate) {
      var option = createCandidateOption(candidate);
      fragment.appendChild(option);
      return { candidate: candidate, option: option };
    });
    layoutOptions.appendChild(fragment);
    var rendered = candidateOptions.filter(function (entry) {
      return entry.candidate.kind !== 'create-my-own';
    }).map(function (entry) {
      if (!sampleBrowser) return Promise.reject(new Error('Sample browser is unavailable.'));
      return sampleBrowser.mount(
        entry.option.querySelector('[data-configurator-sample-preview]'),
        entry.candidate.id
      );
    });

    Promise.all(rendered).then(function () {
      if (destroyed || token !== layoutPreparationToken) return;
      layoutPreparationStatus = 'ready';
      layoutPreparationMessage = 'Drag a sleeve to inspect its reverse, then choose a direction.';
      configuratorRoot.setAttribute('data-configurator-layout-status', 'ready');
      configuratorRoot.setAttribute('data-configurator-layout-candidate-count', String(candidateOptions.length));
      render(state, { type: 'layouts:ready', focus: false });
    }).catch(function () {
      if (destroyed || token !== layoutPreparationToken) return;
      layoutCandidates = [];
      layoutOptions.textContent = '';
      layoutPreparationStatus = 'error';
      layoutPreparationMessage = 'These designs could not be rendered. Refresh and try again.';
      configuratorRoot.setAttribute('data-configurator-layout-status', 'error');
      render(state, { type: 'layouts:error', focus: false });
    });
  }

  function prepareLayoutStage(snapshot) {
    if (!layoutEngine || !designDocuments || !designRecipes || !sampleBrowser) {
      layoutPreparationStatus = 'error';
      layoutPreparationMessage = 'Design choices could not be prepared. Refresh and try again.';
      configuratorRoot.setAttribute('data-configurator-layout-status', 'error');
      return;
    }

    var fingerprint = layoutEngine.getFingerprint(snapshot.configuration);
    if (
      fingerprint === layoutCandidateFingerprint &&
      (layoutPreparationStatus === 'loading' || layoutPreparationStatus === 'ready')
    ) return;

    layoutCandidateFingerprint = fingerprint;
    layoutPreparationStatus = 'loading';
    layoutPreparationMessage = 'Preparing your designs…';
    layoutCandidates = [];
    if (sampleBrowser) sampleBrowser.clear();
    layoutOptions.textContent = '';
    layoutPreparationToken += 1;
    var token = layoutPreparationToken;
    configuratorRoot.setAttribute('data-configurator-layout-status', 'loading');
    configuratorRoot.setAttribute('data-configurator-layout-fingerprint', fingerprint);
    configuratorRoot.removeAttribute('data-configurator-layout-candidate-count');

    Promise.resolve().then(function () {
      if (destroyed || token !== layoutPreparationToken) return;
      layoutCandidates = designRecipes.generate(snapshot.configuration).filter(function (candidate) {
        return candidate.document && designDocuments.validateDocument(candidate.document, snapshot.configuration);
      });
      if (!layoutCandidates.length) {
        layoutPreparationStatus = 'error';
        layoutPreparationMessage = 'No valid designs could be prepared for this content.';
        configuratorRoot.setAttribute('data-configurator-layout-status', 'error');
        render(state, { type: 'layouts:empty', focus: false });
        return;
      }
      buildCandidateOptions(layoutCandidates, token);
    }).catch(function () {
      if (destroyed || token !== layoutPreparationToken) return;
      layoutPreparationStatus = 'error';
      layoutPreparationMessage = 'These designs could not be prepared. Refresh and try again.';
      configuratorRoot.setAttribute('data-configurator-layout-status', 'error');
      render(state, { type: 'layouts:error', focus: false });
    });
  }

  function render(snapshot, action) {
    var index = stageIndex(snapshot.workflow.currentStage);
    var stage = WORKFLOW[index];
    var readiness = currentReadiness();
    if (!stage) return;

    var createStageActive = isCreateStage(stage.id);
    panel.setAttribute('data-configurator-stage', stage.id);
    panel.setAttribute('data-configurator-stage-group', createStageActive ? 'create' : stage.id);
    panel.classList.toggle('is-development-preview', index > ACTIVE_STAGE_LIMIT);
    progressLabel.textContent = 'Step ' + (index + 1) + ' of ' + WORKFLOW.length;
    progress.setAttribute('aria-valuenow', String(index + 1));
    progressValue.style.width = ((index + 1) / WORKFLOW.length * 100) + '%';
    eyebrow.textContent = createStageActive ? 'Create your sleeve' : stage.eyebrow;
    title.textContent = createStageActive ? 'Create Your Sleeve' : stage.title;
    description.textContent = createStageActive
      ? 'Define what should go on your sleeve, one focused decision at a time.'
      : stage.description;
    support.textContent = createStageActive
      ? 'Completed decisions stay close by without getting in your way.'
      : stage.support;

    Array.prototype.forEach.call(stageViews, function (view) {
      var viewStageId = view.getAttribute('data-configurator-stage-view');
      if (isCreateStage(viewStageId)) {
        var active = createStageActive && viewStageId === stage.id;
        view.hidden = !createStageActive;
        view.setAttribute('data-active', active ? 'true' : 'false');
        view.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) view.removeAttribute('inert');
        else view.setAttribute('inert', '');
        return;
      }
      view.hidden = viewStageId !== stage.id;
    });

    renderProgressiveStage(snapshot, stage.id);
    renderLogo(snapshot);
    renderContent(snapshot, stage.id === 'content' ? readiness : validateContentStage(snapshot));
    renderDetails(snapshot, validateDetailsStage(snapshot));
    if (stage.id === 'layouts') prepareLayoutStage(snapshot);
    renderLayoutArrival(snapshot);

    backButton.hidden = createStageActive || index === 0 || stage.id === 'layouts';
    nextButton.hidden = !DEBUG_MODE && index >= ACTIVE_STAGE_LIMIT;
    nextButton.disabled = uploadBusy || !readiness.ready || index === WORKFLOW.length - 1;
    if (stage.id === 'logo') {
      nextButton.textContent = uploadBusy ? 'Adding logo…' : snapshot.configuration.logo ? 'Continue to content' : 'Continue without a logo';
    } else if (stage.id === 'content') {
      nextButton.textContent = 'Start Designing';
    } else if (stage.id === 'layouts') {
      nextButton.textContent = 'Back to My Design';
    } else {
      nextButton.textContent = 'Continue';
    }
    readinessMessage.textContent = readiness.ready ? '' : readiness.reason;

    if (action && action.focus) {
      var subsectionHeading = createStageActive
        ? Array.prototype.find.call(subsectionHeadings, function (heading) {
          return heading.getAttribute('data-configurator-subsection-heading') === stage.id;
        })
        : null;
      (subsectionHeading || title).focus({ preventScroll: true });
    }
  }

  function getState() {
    return clone(state);
  }

  function getLogoAsset() {
    if (!state.configuration.logo || !logoAssetStore) return Promise.resolve(null);
    return logoAssetStore.get(state.configuration.logo.assetId);
  }

  function triggerLogoInput() {
    if (!uploadBusy) logoInput.click();
  }

  function centerUploadedLogo() {
    var document = state.configuration.design.document;
    var logoSide = 'front';
    if (document && document.sides && layoutEngine) {
      var centeredDocument = clone(document);
      var safeArea = layoutEngine.safeArea;
      var artworkSize = layoutEngine.artworkSize;
      var centerX = (safeArea.x + safeArea.width / 2) / artworkSize.width;
      var centerY = (safeArea.y + safeArea.height / 2) / artworkSize.height;
      var foundLogo = false;
      ['front', 'back'].some(function (side) {
        var objects = centeredDocument.sides[side] && centeredDocument.sides[side].objects;
        if (!Array.isArray(objects)) return false;
        var logoObject = objects.find(function (object) {
          return object && object.type === 'image' && object.assetRef &&
            object.assetRef.kind === 'semantic' && object.assetRef.reference === 'logo';
        });
        if (!logoObject) return false;
        logoObject.frame.x = centerX - logoObject.frame.width / 2;
        logoObject.frame.y = centerY - logoObject.frame.height / 2;
        logoObject.style.align = 'center';
        logoSide = side;
        foundLogo = true;
        return true;
      });
      if (foundLogo) updateDesignDocument(centeredDocument, { type: 'design-document:logo-centered' });
    }
    if (
      configuratorRoot.configuratorPresentation &&
      configuratorRoot.configuratorPresentation.orientForLogo
    ) configuratorRoot.configuratorPresentation.orientForLogo(logoSide);
  }

  function handleLogoFile(file) {
    if (!file || uploadBusy) return;
    if (!logoAssetStore) {
      logoMessage = 'Logo storage is unavailable in this browser.';
      logoMessageTone = 'error';
      render(state, { type: 'logo:error', focus: false });
      return;
    }

    var previousLogo = state.configuration.logo;
    var previousLogoAssetStatus = logoAssetStatus;
    uploadBusy = true;
    logoMessage = 'Checking your logo…';
    logoMessageTone = '';
    render(state, { type: 'logo:validating', focus: false });

    logoAssetStore.save(file).then(function (saved) {
      if (destroyed) {
        logoAssetStore.remove(saved.metadata.assetId);
        return;
      }
      logoAssetStatus = 'ready';
      var enabled = addUnique(state.configuration.content.enabledTypes, 'logo');
      var updated = updateConfiguration({
        logo: saved.metadata,
        content: { enabledTypes: enabled }
      });
      if (!updated) {
        logoAssetStore.remove(saved.metadata.assetId);
        throw new Error('The logo could not be added to this configuration.');
      }
      centerUploadedLogo();
      if (previousLogo && previousLogo.assetId !== saved.metadata.assetId) logoAssetStore.remove(previousLogo.assetId);
      logoMessage = saved.persisted ? 'Logo accepted and saved for this session.' : 'Logo accepted. This browser may require it again after refresh.';
      logoMessageTone = 'success';
      configuratorRoot.setAttribute('data-configurator-logo-asset-status', 'ready');
      if (state.workflow.currentStage === 'logo') goNext();
    }).catch(function (error) {
      logoAssetStatus = previousLogo ? previousLogoAssetStatus : 'none';
      logoMessage = error && error.message ? error.message : 'That logo could not be added.';
      logoMessageTone = 'error';
    }).then(function () {
      uploadBusy = false;
      logoInput.value = '';
      render(state, { type: 'logo:complete', focus: false });
    });
  }

  function removeLogo() {
    var previousLogo = state.configuration.logo;
    if (!previousLogo) return;
    logoAssetStatus = 'none';
    revokeLogoThumbnail();
    logoMessage = 'Logo removed. You can add another at any time.';
    logoMessageTone = 'success';
    updateConfiguration({
      logo: null,
      content: { enabledTypes: withoutValue(state.configuration.content.enabledTypes, 'logo') }
    });
    configuratorRoot.setAttribute('data-configurator-logo-asset-status', 'none');
    if (logoAssetStore) logoAssetStore.remove(previousLogo.assetId);
  }

  function handleContentToggle(input) {
    var enabled = state.configuration.content.enabledTypes.slice();
    if (input.checked) {
      enabled = addUnique(enabled, input.value);
      if (FIELD_CONTENT_MODULES.indexOf(input.value) !== -1) expandedContentModule = input.value;
    } else {
      enabled = withoutValue(enabled, input.value);
      if (expandedContentModule === input.value) expandedContentModule = null;
    }
    updateConfiguration({ content: { enabledTypes: enabled } });
  }

  function toggleContentEditor(moduleId) {
    if (
      FIELD_CONTENT_MODULES.indexOf(moduleId) === -1 ||
      state.configuration.content.enabledTypes.indexOf(moduleId) === -1
    ) return;
    expandedContentModule = expandedContentModule === moduleId ? null : moduleId;
    render(state, { type: 'content:disclosure', focus: false });
  }

  function updateDetail(input) {
    var key = input.getAttribute('data-configurator-detail');
    var values = clone(state.configuration.content.values);
    var previousValue = key.indexOf('restaurantInfo.') === 0
      ? values.restaurantInfo[key.split('.')[1]]
      : values[key];
    if (previousValue === input.value) return false;
    if (key.indexOf('restaurantInfo.') === 0) values.restaurantInfo[key.split('.')[1]] = input.value;
    else values[key] = input.value;
    var updated = updateConfiguration({ content: { values: values } });
    if (
      updated &&
      configuratorRoot.configuratorPresentation &&
      configuratorRoot.configuratorPresentation.orientForSemanticInput
    ) configuratorRoot.configuratorPresentation.orientForSemanticInput(key);
    return updated;
  }

  function returnToLogo(message) {
    logoMessage = message || '';
    logoMessageTone = '';
    goToStage('logo');
  }

  function findLayoutCandidate(layoutId) {
    return layoutCandidates.find(function (candidate) { return candidate.id === layoutId; }) || null;
  }

  function selectLayout(layoutId) {
    var candidate = findLayoutCandidate(layoutId);
    if (!candidate || !designDocuments || !designDocuments.validateDocument(candidate.document, state.configuration)) return false;
    if (
      candidate.kind !== 'create-my-own' &&
      !window.confirm(
        'Apply this sample? It will replace the current sleeve layout and will not automatically include your existing logo or content. Your saved content will remain available if you return to your own design.'
      )
    ) return false;
    var selected = updateDesignDocument(candidate.document, { type: 'design-document:starting-layout-selected' });
    if (selected && state.workflow.currentStage === 'layouts') return goToStage('edit');
    return selected;
  }

  function handlePanelClick(event) {
    var target = event.target;
    var subsectionTrigger = target.closest('[data-configurator-subsection-trigger]');
    if (subsectionTrigger && !subsectionTrigger.closest('[data-configurator-subsection]').hidden) {
      goToStage(subsectionTrigger.getAttribute('data-configurator-subsection-trigger'));
      return;
    }
    var layoutOption = target.closest('[data-configurator-layout-option]');
    if (layoutOption) {
      selectLayout(layoutOption.getAttribute('data-configurator-layout-option'));
      return;
    }
    if (target.closest('[data-configurator-layout-logo-recovery]')) {
      returnToLogo('Re-upload your logo to continue with design choices. Your other content is still here.');
      return;
    }
    if (target.closest('[data-configurator-logo-choose], [data-configurator-logo-replace]')) {
      triggerLogoInput();
      return;
    }
    if (target.closest('[data-configurator-logo-remove]')) {
      removeLogo();
      return;
    }
    if (target.closest('[data-configurator-content-logo-action]')) {
      returnToLogo('Add a valid logo to include it on the sleeve.');
      return;
    }
    var contentEditor = target.closest('[data-configurator-content-edit]');
    if (contentEditor) {
      toggleContentEditor(contentEditor.getAttribute('data-configurator-content-edit'));
      return;
    }
    if (target.closest('[data-configurator-back]')) {
      goBack();
      return;
    }
    if (target.closest('[data-configurator-next]')) goNext();
  }

  function handlePanelChange(event) {
    if (event.target.matches('[data-configurator-logo-input]')) {
      handleLogoFile(event.target.files && event.target.files[0]);
      return;
    }
    if (event.target.matches('[data-configurator-content-module]')) handleContentToggle(event.target);
  }

  function handlePanelInput(event) {
    if (event.target.matches('[data-configurator-detail]')) updateDetail(event.target);
  }

  function handlePanelKeydown(event) {
    var option = event.target.closest('[data-configurator-layout-option]');
    if (!option || ['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft'].indexOf(event.key) === -1) return;
    var options = Array.prototype.slice.call(layoutOptions.querySelectorAll('[data-configurator-layout-option]'));
    var currentIndex = options.indexOf(option);
    if (currentIndex === -1) return;
    event.preventDefault();
    var direction = event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : -1;
    var nextOption = options[(currentIndex + direction + options.length) % options.length];
    nextOption.focus();
  }

  function markLogoAssetMissing() {
    logoAssetStatus = 'missing';
    logoMessage = 'The original logo is no longer available in this browser. Please add it again.';
    logoMessageTone = 'error';
    configuratorRoot.setAttribute('data-configurator-logo-asset-status', 'missing');
    render(state, { type: 'logo:missing', focus: false });
  }

  function reconcileLogoAsset() {
    var logo = state.configuration.logo;
    if (!logo) {
      logoAssetStatus = 'none';
      configuratorRoot.setAttribute('data-configurator-logo-asset-status', 'none');
      if (logoAssetStore) logoAssetStore.prune(designAssetIds(state.configuration));
      render(state, { type: 'logo:none', focus: false });
      return;
    }
    if (!logoAssetStore) {
      markLogoAssetMissing();
      return;
    }

    logoAssetStatus = 'loading';
    configuratorRoot.setAttribute('data-configurator-logo-asset-status', 'loading');
    logoAssetStore.get(logo.assetId).then(function (record) {
      if (destroyed || !state.configuration.logo || state.configuration.logo.assetId !== logo.assetId) return;
      if (!record) {
        markLogoAssetMissing();
        return;
      }
      logoAssetStatus = 'ready';
      logoMessage = restoration.restored ? 'Logo restored for this session.' : logoMessage;
      logoMessageTone = restoration.restored ? 'success' : logoMessageTone;
      configuratorRoot.setAttribute('data-configurator-logo-asset-status', 'ready');
      logoAssetStore.prune(designAssetIds(state.configuration));
      render(state, { type: 'logo:restored', focus: false });
    });
  }

  function handlePageHide(event) {
    if (!event.persisted) destroy();
  }

  function destroy() {
    if (destroyed) return;
    destroyed = true;
    panel.removeEventListener('click', handlePanelClick);
    panel.removeEventListener('change', handlePanelChange);
    panel.removeEventListener('input', handlePanelInput);
    panel.removeEventListener('keydown', handlePanelKeydown);
    layoutOptions.removeEventListener('click', handlePanelClick);
    layoutOptions.removeEventListener('keydown', handlePanelKeydown);
    window.removeEventListener('pagehide', handlePageHide);
    layoutPreparationToken += 1;
    revokeLogoThumbnail();
    subscribers.length = 0;
    configuratorRoot.configuratorApp = null;
  }

  subscribe(render);
  panel.addEventListener('click', handlePanelClick);
  panel.addEventListener('change', handlePanelChange);
  panel.addEventListener('input', handlePanelInput);
  panel.addEventListener('keydown', handlePanelKeydown);
  layoutOptions.addEventListener('click', handlePanelClick);
  layoutOptions.addEventListener('keydown', handlePanelKeydown);
  window.addEventListener('pagehide', handlePageHide);

  configuratorRoot.configuratorApp = {
    getState: getState,
    getReadiness: currentReadiness,
    getLogoAsset: getLogoAsset,
    getSemanticConstraint: function (reference) { return SEMANTIC_LIMITS[reference] || null; },
    getDesignAssetIds: function () { return designAssetIds(state.configuration); },
    goTo: goToStage,
    next: goNext,
    back: goBack,
    updateConfiguration: updateConfiguration,
    updateDesignDocument: updateDesignDocument,
    resetDesignDocument: resetDesignDocument,
    chooseLogo: triggerLogoInput,
    replaceLogoFile: handleLogoFile,
    subscribe: subscribe,
    destroy: destroy,
    persistence: {
      storageKey: STORAGE_KEY,
      schemaVersion: SCHEMA_VERSION
    }
  };
  if (DEBUG_MODE) {
    configuratorRoot.configuratorApp.debug = {
      workflow: WORKFLOW.map(function (stage) { return stage.id; }),
      goTo: function (stageId) { return goToStage(stageId); }
    };
  }

  render(state, { type: restoration.restored ? 'draft:restored' : 'app:initialized', focus: false });
  if (restoration.migrated || restoration.normalized) persistState();
  if (restoration.discardedLogoAssetId && logoAssetStore) logoAssetStore.remove(restoration.discardedLogoAssetId);
  reconcileLogoAsset();
}());
